import { Config } from './types';

// @ts-expect-error Type 'Config | {}' is not assignable to type 'Config'.
const config: Config = typeof window.__CREW_BRAIN__ !== 'undefined' ? window.__CREW_BRAIN__.config : {};

export default config;
